import React, { useState } from "react";
import { Icon } from "@iconify/react";

const QuestionCard = ({ faq }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden transition-all duration-200">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between p-5 text-left font-bold text-slate-700 hover:bg-slate-50/50 transition duration-150 focus:outline-none"
      >
        <span className="text-sm pr-4">{faq?.question}</span>
        <Icon
          icon="solar:alt-arrow-down-bold"
          className={`w-4 h-4 text-slate-400 transition-transform duration-200 flex-shrink-0 ${
            isOpen ? "transform rotate-180 text-secondary" : ""
          }`}
        />
      </button>

      {isOpen && (
        <div className="px-5 pb-5 border-t border-slate-50 pt-4 bg-slate-50/25">
          <p className="text-xs font-semibold text-slate-500 leading-relaxed">{faq?.answer}</p>
        </div>
      )}
    </div>
  );
};

export default QuestionCard;
